<template>
  <div>
    <v-tabs
      v-model="currentStatus"
      background-color="kbWhite"
      color="kbBlue"
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        v-for="({ name }, index) in statusItems"
        :key="index"
      >
        {{ name }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  computed: {
    statusItems () {
      return [
        { name: this.$t('general.total'), filterBy: 'status', value: '', isPositive: true },
        { name: this.$tc('general.sent', 2), filterBy: 'status', value: 'sent', isPositive: true },
        { name: this.$tc('general.deliveredPlural', 2), filterBy: 'responseStatus', value: 'delivered', isPositive: true },
        { name: this.$tc('general.opened', 2), filterBy: 'responseStatus', value: 'opened', isPositive: true },
        { name: this.$tc('general.clickedPlural', 2), filterBy: 'responseStatus', value: 'clicked', isPositive: true },
        { name: this.$tc('general.deferral', 2), filterBy: 'responseStatus', value: 'deferral', isPositive: false },
        { name: this.$tc('general.rejected', 2), filterBy: 'responseStatus', value: 'rejected', isPositive: false },
        { name: this.$tc('general.hardBounced', 2), filterBy: 'responseStatus', value: 'hardBounced', isPositive: false },
        { name: this.$tc('general.pending', 2), filterBy: 'responseStatus', value: 'pending', isPositive: false },
        { name: this.$tc('general.scheduled', 2), filterBy: 'responseStatus', value: 'scheduled', isPositive: false },
        { name: this.$tc('general.queued', 2), filterBy: 'responseStatus', value: 'queued', isPositive: false },
        { name: this.$tc('general.softBounced', 2), filterBy: 'responseStatus', value: 'softBounced', isPositive: false },
        { name: this.$tc('general.spamBlocked', 2), filterBy: 'responseStatus', value: 'spam', isPositive: false },
        { name: this.$tc('general.unsubscribed', 2), filterBy: 'responseStatus', value: 'unsub', isPositive: false },
        { name: this.$t('general.blackList'), filterBy: 'responseStatus', value: 'blackList', isPositive: false },
        { name: this.$t('general.whiteList'), filterBy: 'responseStatus', value: 'whiteList', isPositive: false },
        { name: this.$tc('general.unknown', 2), filterBy: 'responseStatus', value: 'unknown', isPositive: false }
      ]
    },
    currentStatus: {
      get () {
        return this.tab
      },
      set (tab) {
        this.tab = tab
        const { value, filterBy } = this.statusItems[tab]
        this.$emit('onStatusChange', { value, filterBy })
      }
    }
  },
  data () {
    return {
      tab: 0
    }
  }
}
</script>
